import { getMenuActive, menuAction } from "@/shared/menu/menuSlice";
import { useDispatch, useSelector } from "react-redux";

export const useMenu = () => {
  const appDispatch = useDispatch();
  const { changeMenuActive } = menuAction;
  const menuSelected = useSelector(getMenuActive);

  const atualizarMenuSelected = (key: string[]) => {
    appDispatch(changeMenuActive(key));
  };

  return {
    atualizarMenuSelected,
    menuSelected,
  };
};
